// extracted by mini-css-extract-plugin
module.exports = {"zoomImage":"ZoomImage-module--zoomImage--lE-GA","zoomImage__image":"ZoomImage-module--zoomImage__image--1MpM2"};